<div class="relative ml-1 max-w-[475px]">
  @if (language()) {
    <textarea
      class="size-full min-h-[72px] resize-none rounded-md border border-grey-midGrey py-[10px] pl-[34px] text-base outline-0 placeholder:text-grey focus:border focus:border-blue"
      [id]="name() + language()"
      [placeholder]="placeholder()"
      [attr.maxlength]="maxLength()"
      [value]="value()"
      (input)="onInput($event)"
      (blur)="onBlur($event)"
      (focus)="onFocus()"
    ></textarea>
    <span class="absolute left-0 top-0 pl-[14px] pt-[17px]">
      @if (language() === 'DE') {
        <img
          src="/assets/flags/de.svg"
          alt="Deutsch"
          title="Deutsch"
          class="flag-icon"
          width="16px"
        />
      } @else if (language() === 'EN') {
        <img
          src="/assets/flags/gb.svg"
          alt="English"
          title="English"
          class="flag-icon"
          width="16px"
        />
      }
    </span>
    @if (isFocused()) {
      <span
        class="pointer-events-none absolute bottom-2 right-2 text-xs text-grey"
      >
        {{ currentLength() }}/{{ maxLength() }}
      </span>
    }
  } @else {
    <textarea
      class="peer size-full min-h-[72px] resize-none rounded-md border border-grey-midGrey p-2 text-base outline-0 placeholder:text-grey focus:border focus:border-blue"
      [placeholder]="placeholder()"
    ></textarea>
  }
</div>
